import '@iotize/tap/service/impl/device';

import { defineTapPropertyExtension, Tap } from '@iotize/tap';
import { TapConfiguratorConfig } from '@iotize/tap/config/schema/v1';
import {
  TapConfiguratorReader,
  TapConfiguratorWriter,
} from '@iotize/tap/configurator';

declare module '@iotize/tap/lib/tap' {
  interface Tap {
    // applyConfig(
    //     conf: TapConfiguratorConfig
    // ): Observable<TapConfiguratorWriter.Event>;

    configurator: TapConfiguratorExtension;
  }
}

// export function applyConfig(this: Tap, schema: TapConfiguratorConfig) {
//     return new SchemaTapConfigurator(schema, {
//         delayMs: 400
//     }).configure(this);
// }
export const _TAP_EXTENSION_CONFIGURATOR_ = defineTapPropertyExtension(
  'configurator',
  (context) => new TapConfiguratorExtension(context),
);

/**
 * @deprecated use _TAP_EXTENSION_CONFIGURATOR_ instead
 */
export const __DEFINED_PROPERTY_GETTER_CONFIGURATOR_ =
  _TAP_EXTENSION_CONFIGURATOR_;

// Tap.prototype.applyConfig = applyConfig;

/**
 * Tempory class in order not to break SchemaTapConfigurator API
 */
export class TapConfiguratorExtension {
  private configuratorWriter: TapConfiguratorWriter;
  private configuratorReader: TapConfiguratorReader;

  private get tap() {
    return this.context.tap;
  }

  constructor(
    public context: {
      tap: Tap;
    },
    options?: TapConfiguratorWriter.Options,
  ) {
    this.configuratorWriter = new TapConfiguratorWriter(options);
    this.configuratorReader = new TapConfiguratorReader();
  }

  // get _schemaConfigurator() {
  //     const schema = new TapConfiguratorWriter(this.options);
  //     schema.tap = this.tap;
  //     return schema;
  // }

  async setup(
    schema: TapConfiguratorConfig,
    options?: TapConfiguratorWriter.ConfigureOptions,
  ) {
    const firmwareVersion = (
      await this.tap.service.device.getFirmwareVersion()
    ).body();
    return this.configuratorWriter.configure(
      this.tap,
      firmwareVersion,
      schema,
      options,
    );
  }

  setupConfigState() {
    return this.configuratorWriter.setupConfigState(this.tap);
  }

  applyConfig(newVersion = '1.0.0') {
    return this.configuratorWriter.applyConfig(this.tap, newVersion);
  }

  isConfigured(): Promise<boolean> {
    return this.configuratorWriter.isConfigured(this.tap);
  }

  /**
   * Read configurations
   * Last emitter event will be the configuration keys mapping
   */
  read() {
    return this.configuratorReader
      .createReadOperations(this.tap)
      .asObservable();
  }
}
